// extracted by mini-css-extract-plugin
module.exports = {"slide":"TabSell_slide_1ElYz","slide-reverse":"TabSell_slide-reverse_3pW3D","innerTabStyle":"TabSell_innerTabStyle_1SOEu"};